module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/84a9455c54ab68ad8dcf8b6f6465ae71.svg";